export const home = {
  'Made for': 'Mahetab Shaikh',
};
